module.exports = __webpack_public_path__ + "img/68.0fe34ecf.png";